import { render, staticRenderFns } from "./feedbacklist.vue?vue&type=template&id=1afc37ee&scoped=true"
import script from "./feedbacklist.vue?vue&type=script&lang=js"
export * from "./feedbacklist.vue?vue&type=script&lang=js"
import style0 from "./feedbacklist.vue?vue&type=style&index=0&id=1afc37ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afc37ee",
  null
  
)

export default component.exports